import { stringFormat } from "./string-format";

export const ICON_DEFAULT = "arrow_right";
export const ICON_PHONE = "phone";
export const ICON_MAIL = "notification";
export const ICON_DOWNLOAD = "download";
export const ICON_TWITTER = "social_twitter";
export const ICON_YOUTUBE = "social_youtube";
export const ICON_FACEBOOK = "social_facebook";
export const ICON_INSTAGRAM = "social_instagram";
export const ICON_LINKEDIN = "social_linked_in";
export const ICON_PINTEREST = "social_pinterest";
export const ICON_SNAPCHAT = "social_snapchat";
export const ICON_SPOTIFY = "social_spotify";
export const ICON_CONNECT = "social_connect";
export const ICON_TIKTOK = "social_tiktok";
export const ICON_PLAY = "play";
export const ICON_VIDEO_REPLAY = "video_replay";
export const ICON_LOCATION = "location";
export const ICON_XING = "social_xing";
export const ICON_KUNUNU = "social_kununu";
export const ICON_EXTERNAL = "link_external";

export const LINK_ICONS = [
  ICON_DEFAULT,
  ICON_PHONE,
  ICON_MAIL,
  ICON_DOWNLOAD,
  ICON_TWITTER,
  ICON_YOUTUBE,
  ICON_FACEBOOK,
  ICON_INSTAGRAM,
  ICON_LINKEDIN,
  ICON_PINTEREST,
  ICON_SNAPCHAT,
  ICON_SPOTIFY,
  ICON_CONNECT,
  ICON_TIKTOK,
  ICON_LOCATION,
  ICON_XING,
  ICON_KUNUNU,
  ICON_EXTERNAL
] as const;

export const LinkIcons = {
  default: ICON_DEFAULT,
  phone: ICON_PHONE,
  mail: ICON_MAIL,
  download: ICON_DOWNLOAD,
  twitter: ICON_TWITTER,
  youtube: ICON_YOUTUBE,
  facebook: ICON_FACEBOOK,
  instagram: ICON_INSTAGRAM,
  linkedin: ICON_LINKEDIN,
  pinterest: ICON_PINTEREST,
  snapchat: ICON_SNAPCHAT,
  spotify: ICON_SPOTIFY,
  connect: ICON_CONNECT,
  tiktok: ICON_TIKTOK,
  location: ICON_LOCATION,
  xing: ICON_XING,
  kununu: ICON_KUNUNU,
  external: ICON_EXTERNAL
};

/**
 * ComputeLinkIcon will compute the icons
 * on basis of input given to href
 */
export const ComputeLinkIcon = (href: string, download, type) => {
  let icon: string = type === "link" ? LinkIcons.default : undefined;
  const target = href?.toLowerCase();

  if (target && href) {
    if (target.startsWith("tel:")) {
      icon = LinkIcons.phone;
    } else if (target.startsWith("mailto:")) {
      icon = LinkIcons.mail;
    } else if (target.startsWith("file://") || download) {
      icon = LinkIcons.download;
    } else if (target.includes("twitter.")) {
      icon = LinkIcons.twitter;
    } else if (target.includes("youtube.") || target.includes("youtu.be")) {
      icon = LinkIcons.youtube;
    } else if (target.includes("facebook.") || target.includes("fb.me")) {
      icon = LinkIcons.facebook;
    } else if (target.includes("instagram.")) {
      icon = LinkIcons.instagram;
    } else if (target.includes("linkedin.") || target.includes("lnkd.in")) {
      icon = LinkIcons.linkedin;
    } else if (target.includes("pinterest.")) {
      icon = LinkIcons.pinterest;
    } else if (target.includes("snapchat.")) {
      icon = LinkIcons.snapchat;
    } else if (target.includes("maps.google")) {
      icon = LinkIcons.location;
    } else if (target.includes("spotify")) {
      icon = LinkIcons.spotify;
    } else if (target.includes("connect.")) {
      icon = LinkIcons.connect;
    } else if (target.includes("tiktok.com")) {
      icon = LinkIcons.tiktok;
    } else if (target.includes("xing.")) {
      icon = LinkIcons.xing;
    } else if (target.includes("kununu.")) {
      icon = LinkIcons.kununu;
    } else {
      // Check up for external links
      // Always has to be the last check as the external icon should only be shown if no other service matches.
      let tempLink = document.createElement("a");
      tempLink.href = target;
      tempLink.host !== window.location.host && (icon = LinkIcons.external);
    }
  }
  return icon;
};

/**
 * Specifies the label to use for accessibility.
 */
export const computeLinkAriaLabel = (currentLocalization, href: string, download) => {
  let label: string = stringFormat(currentLocalization.ariaLabel.default, href);
  if (href) {
    if (href.startsWith("tel:")) {
      label = stringFormat(currentLocalization.ariaLabel.phone, href.replace("tel:", ""));
    } else if (href.startsWith("mailto:")) {
      label = stringFormat(currentLocalization.ariaLabel.mail, href.replace("mailto:", ""));
    } else if (href.startsWith("file:") || download) {
      label = stringFormat(currentLocalization.ariaLabel.download, href.replace("file://", ""));
    }
  }
  return label;
};
